/* ============================================================
   tio-collection.js — panel "Filtrar y ordenar" de la coleccion.

   El filtrado NO vive aca. El panel es un <form method="get"> nativo:
   enviarlo recarga la coleccion filtrada server-side por Shopify. Este
   archivo solo agrega la capa de comodidad:
     - abrir / cerrar el panel (sheet movil, drawer desktop)
     - acordeones de grupo
     - el punto/tick de cada fila (clase .is-on)
     - los 3 presets de precio -> los inputs reales gte/lte
     - el contador EN VIVO del CTA, via Section Rendering API
     - swipe-down para cerrar en movil

   DOCTRINA 8.1: todos los listeners son DELEGADOS en document. El DOM de
   la coleccion se re-renderiza (paginacion, Section Rendering API) y los
   handlers por-elemento morirsan con el nodo.
   ============================================================ */
(function () {
  'use strict';

  var ENTRADA = 460;   /* ms — coincide con el CSS del sheet */
  var SALIDA = 320;

  function panel() { return document.querySelector('[data-tio-fp]'); }
  function form() { return document.querySelector('[data-tio-fp-form]'); }

  /* ---------------- Scroll lock ---------------- */
  function bloquearScroll(si) {
    if (si) {
      var comp = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (comp > 0) document.body.style.paddingRight = comp + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  /* ---------------- Abrir / cerrar ---------------- */
  function abrir() {
    var ov = panel();
    if (!ov || ov.classList.contains('is-active')) return;
    ov.classList.add('is-active');
    var f = form();
    if (f) f.setAttribute('aria-hidden', 'false');
    var btn = document.querySelector('[data-tio-fp-abrir]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    bloquearScroll(true);
  }

  function cerrar() {
    var ov = panel();
    if (!ov || !ov.classList.contains('is-active')) return;
    ov.classList.remove('is-active');
    var f = form();
    if (f) {
      f.style.transform = '';
      /* aria-hidden recien cuando la transicion termino, no antes */
      setTimeout(function () {
        if (!ov.classList.contains('is-active')) f.setAttribute('aria-hidden', 'true');
      }, SALIDA);
    }
    var btn = document.querySelector('[data-tio-fp-abrir]');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    bloquearScroll(false);
  }

  /* ---------------- Presets de precio ----------------
     Cada radio trae "desde|hasta" en pesos. Los inputs que Shopify
     realmente lee son los hidden gte/lte; esto solo los completa. */
  function aplicarPreset(radio) {
    var f = form();
    if (!f) return;
    var desde = f.querySelector('[data-tio-precio-desde]');
    var hasta = f.querySelector('[data-tio-precio-hasta]');
    var partes = String(radio.value).split('|');
    if (desde) desde.value = partes[0] || '';
    if (hasta) hasta.value = partes[1] || '';
  }

  /* ---------------- Contador en vivo del CTA ----------------
     Pide la MISMA section con los filtros del borrador y lee el total
     que el propio Liquid ya calculo. Una sola fuente de verdad: no se
     recuenta nada en JS. */
  var pidiendo = null;
  var reloj = null;

  function parametros(f) {
    var p = new URLSearchParams();
    var campos = f.querySelectorAll('input[name], select[name]');
    for (var i = 0; i < campos.length; i++) {
      var el = campos[i];
      if (el.disabled || !el.name) continue;
      if (el.name === 'tio_precio') continue;              /* auxiliar, no es de Shopify */
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      if (el.value === '') continue;                        /* gte/lte vacios no viajan */
      p.append(el.name, el.value);
    }
    return p;
  }

  function actualizarContador() {
    var f = form();
    if (!f) return;
    var cta = f.querySelector('[data-tio-fp-cta]');
    if (!cta) return;

    var base = f.getAttribute('data-tio-url') || window.location.pathname;
    var sec = f.getAttribute('data-tio-section');
    var p = parametros(f);
    p.set('section_id', sec);

    if (pidiendo) pidiendo.abort();
    pidiendo = new AbortController();

    fetch(base + '?' + p.toString(), { signal: pidiendo.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var marca = doc.querySelector('[data-tio-total]');
        if (!marca) return;
        var n = parseInt(marca.getAttribute('data-tio-total'), 10);
        if (isNaN(n)) return;
        if (n === 0) {
          cta.textContent = 'Sin resultados — ajusta los filtros';
          cta.disabled = true;
        } else {
          cta.textContent = 'Ver ' + n + (n === 1 ? ' fragancia' : ' fragancias');
          cta.disabled = false;
        }
      })
      .catch(function (err) {
        /* El contador es comodidad: si falla, el CTA sigue enviando el
           form y Shopify filtra igual. No se rompe nada. */
        if (err.name !== 'AbortError') console.warn('[tio-collection]', err);
      });
  }

  function pedirContador() {
    clearTimeout(reloj);
    reloj = setTimeout(actualizarContador, 260);
  }

  /* ---------------- Listeners delegados ---------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tio-fp-abrir]')) { abrir(); return; }
    if (e.target.closest('[data-tio-fp-cerrar]')) { cerrar(); return; }

    var ov = panel();
    if (ov && e.target === ov) { cerrar(); return; }        /* click en el scrim */

    var head = e.target.closest('[data-tio-fg-head]');
    if (head) {
      var grupo = head.closest('[data-tio-fg]');
      if (!grupo) return;
      var ahora = grupo.classList.toggle('is-open');
      head.setAttribute('aria-expanded', ahora ? 'true' : 'false');
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var campo = e.target;
    if (!campo.matches || !campo.matches('.fo input')) return;

    var fila = campo.closest('.fo');

    if (campo.type === 'radio') {
      /* un solo elegido por grupo de radios */
      var hermanos = document.querySelectorAll('.fo input[type="radio"][name="' + campo.name + '"]');
      for (var i = 0; i < hermanos.length; i++) {
        var f2 = hermanos[i].closest('.fo');
        if (f2) f2.classList.toggle('is-on', hermanos[i].checked);
      }
      if (campo.hasAttribute('data-tio-precio')) aplicarPreset(campo);
    } else if (fila) {
      fila.classList.toggle('is-on', campo.checked);
    }

    pedirContador();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrar();
  });

  /* Antes de enviar, se apagan los campos que no son de Shopify: el radio
     auxiliar del preset y los gte/lte vacios. Si no, la URL queda con
     ?tio_precio=|6000&filter.v.price.gte= — ruido que no filtra nada y
     ensucia lo que el cliente comparte o guarda. */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-tio-fp-form]');
    if (!f) return;
    var campos = f.querySelectorAll('input[name]');
    for (var i = 0; i < campos.length; i++) {
      var el = campos[i];
      if (el.name === 'tio_precio' || el.value === '') el.disabled = true;
    }
  });

  /* ---------------- Swipe-down (solo movil) ---------------- */
  var y0 = null;
  var dy = 0;

  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('[data-tio-fp-drag]')) return;
    if (window.matchMedia('(min-width: 768px)').matches) return;   /* desktop = drawer lateral */
    var f = form();
    if (!f) return;
    y0 = e.touches[0].clientY;
    dy = 0;
    f.style.transition = 'none';
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (y0 === null) return;
    dy = e.touches[0].clientY - y0;
    if (dy < 0) dy = 0;
    var f = form();
    if (f) f.style.transform = 'translateY(' + dy + 'px)';
  }, { passive: true });

  document.addEventListener('touchend', function () {
    if (y0 === null) return;
    var f = form();
    y0 = null;
    if (!f) return;
    f.style.transition = '';
    if (dy > 110) {
      f.style.transform = '';
      cerrar();
    } else {
      f.style.transform = '';
    }
  });

  /* ---------------- Init ----------------
     Los radios de precio nacen disabled para que, SIN JS, no ensucien la
     URL con un parametro que Shopify no entiende. Con JS ya sirven. */
  function iniciar() {
    var f = form();
    if (!f) return;
    var radios = f.querySelectorAll('[data-tio-precio]');
    for (var i = 0; i < radios.length; i++) radios[i].disabled = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
